import React from 'react';
import {useQuery} from "@tanstack/react-query";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import citizenScheduledVisitService from "../../../../../../services/web/citizen-scheduled-visit-service.js";
import {FaExternalLinkAlt} from "react-icons/fa";
import useHasPermission from "../../../../../../hooks/use-has-permission.js";
import {PermissionEnum} from "../../../../../../utils/enums/permission-enum.js";
import InputFile from "../../../../../../components/input/input-file.jsx";
import Dropzone from "../../../../../../components/dropzone/dropzone.jsx";

const formatPrograms = (programs) => {
    if (Array.isArray(programs)) return programs.map(p => p?.label ?? p).join(", ");
    return programs ?? "";
};

const CitizenScheduledVisitExecutionModal = ({id, open, setOpen, openDispatch}) => {
    const hasPermission = useHasPermission();

    const {data: detail, isFetching} = useQuery({
        queryFn: () => citizenScheduledVisitService.get(id),
        queryKey: ["citizen-scheduled-visit-detail", id],
        enabled: !!id && open,
    });

    const isStale = isFetching && !detail?.executionDt;

    return (
        <Modal open={open} setOpen={setOpen} title={"Agendamento"} className={"w-2xl"}>
            <Modal.Body className={"space-y-4 max-h-[85vh] overflow-auto"}>
                <Card>
                    <Card.Header>
                        <Card.Title>Protegido</Card.Title>
                    </Card.Header>
                    <Card.Body className={"grid grid-cols-12 gap-4"}>
                        <InputForm
                            classNameWrapper={"col-span-5"}
                            id={"citizenName"}
                            label={"Nome"}
                            value={detail?.citizenName ?? ""}
                            readOnly
                        />

                        <InputForm
                            classNameWrapper={"col-span-4"}
                            id={"protectionPrograms"}
                            label={"Programa de proteção"}
                            value={formatPrograms(detail?.protectionPrograms)}
                            readOnly
                        />

                        <InputForm
                            classNameWrapper={"col-span-3"}
                            id={"risk"}
                            label={"Grau de risco"}
                            value={detail?.risk}
                            readOnly
                        />
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Header>
                        <Card.Title>Finalização</Card.Title>
                    </Card.Header>
                    <Card.Body className={"grid grid-cols-12 gap-4"}>
                        <InputForm
                            classNameWrapper={"col-span-7"}
                            id={"executionUser"}
                            label={"Realizado por"}
                            value={isStale ? "" : (detail?.executionUserName ?? "")}
                            readOnly
                        />

                        <InputForm
                            classNameWrapper={"col-span-5"}
                            id={"executionDt"}
                            label={"Data/hora da execução"}
                            value={isStale ? "" : (detail?.executionDt ? projectUtils.formatDate(detail.executionDt) : "")}
                            readOnly
                        />

                        <InputTextarea
                            className={"col-span-12"}
                            textAreaClass={"h-24!"}
                            id={"executionDescription"}
                            label={"Descrição"}
                            value={isStale ? "" : (detail?.executionDescription ?? "")}
                            disabled
                            readOnly
                        />

                        {
                            detail?.signatureAttachId &&
                            <InputFile
                                className={"col-span-4"}
                                file={{name: "signature.jpg", attachId: detail?.signatureAttachId, extension: "image/jpg"}}
                                isRemove={false}
                                titleWithFile={"Visualizar assinatura"}
                            />
                        }

                    </Card.Body>
                </Card>

                {
                    detail?.attaches?.length > 0 &&
                    <Dropzone
                        title={"Anexos"}
                        attaches={detail?.attaches ?? []}
                        disabled={true}
                    />
                }

                {(detail?.dispatchId && hasPermission(PermissionEnum.DISPATCH_DISPATCH)) && (
                    <div className={"col-span-12 flex items-center gap-2"}>
                        <span className={"text-sm text-gray-500"}>Despacho vinculado:</span>
                        <button
                            type={"button"}
                            onClick={() => openDispatch(detail.dispatchId)}
                            className={"inline-flex items-center gap-1 text-sm font-semibold text-[#063A6C] hover:underline cursor-pointer"}
                        >
                            <FaExternalLinkAlt size={12}/> Abrir despacho
                        </button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default CitizenScheduledVisitExecutionModal;
